
export type DashboardGroup = {
    id: string
    name: string
}

export type DashboardConfig = {
    layout: 'cards' | 'list'
    groupBuckets: boolean
    groups: DashboardGroup[]
}

export type HeaderConfig = {
    galleries: {
        image: boolean
        video: boolean
        file: boolean
        audio: boolean
    }
}

export type CmsConfig = {
    shareable: {
        title: string
        lifetime: number
        showInGalleries: boolean
    }
    locales: string[]
    images: StoredResponsiveImageConfig
    videos: StoredVideoTranscodeConfig
    files: StoredFileConfig
    audio: StoredAudioVariantConfig
    header: HeaderConfig
    dashboard: DashboardConfig
}

// The part of the config every signed-in user needs at app boot; the full config is admin-only.
export type ClientCmsConfig = {
    locales: string[]
    header: HeaderConfig
    dashboard: DashboardConfig
    shareable: { showInGalleries: boolean }
    images: { altTextEnabled: boolean }
    uploadLimits: UploadLimits
}

// Maximum upload size per asset kind in bytes, so editors can refuse an oversized file before sending any of it.
export type UploadLimits = {
    image: number
    video: number
    file: number
    audio: number
}

export const DEFAULT_AUDIO_MAX_UPLOAD_BYTES = 50 * 1024 * 1024

export const DEFAULT_HEADER_CONFIG: HeaderConfig = {
    galleries: {
        image: true,
        video: true,
        file: true,
        audio: true,
    },
}

export const DEFAULT_DASHBOARD_CONFIG: DashboardConfig = {
    layout: 'cards',
    groupBuckets: false,
    groups: [],
}
